import React from 'react';
import "tabler-react/dist/Tabler.css";
import { Page, Icon } from "tabler-react";

function RiesgoAlumno() {
	return (
		<>
			<Page.Content className="page-riesgo-alumno">
			<Page.Title><Icon prefix="fe" name="activity" />Riesgo del Alumno</Page.Title>
			</Page.Content>
		</>
	);
}

export default RiesgoAlumno;